"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var getAuthenticationUrlOperation_1 = require("./operation/getAuthenticationUrlOperation");
var WAIT_TIME_AFTER_ATTEMPT = 82800000; // 23 Hours in Milliseconds.
var ONEMINUTE = 60000; // 1 Minute in Milliseconds.
var BACKGROUND_AUTH = 'backgroundauth';
var iframe = null;
var lastAttemptTime = null;
var windowObj = null;
function tryBackgroundAuth(window) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            if (iframe != null) {
                return [2 /*return*/];
            }
            if (lastAttemptTime != null && Date.now() - lastAttemptTime < WAIT_TIME_AFTER_ATTEMPT) {
                return [2 /*return*/];
            }
            else {
                lastAttemptTime = Date.now();
            }
            windowObj = window;
            iframe = windowObj.document.createElement('iframe');
            iframe.setAttribute('id', BACKGROUND_AUTH);
            iframe.style.display = 'none';
            getAuthenticationUrlOperation_1.default().then(function (response) {
                if (response.ResultCode != 0 /* Success */ || response.AuthenticationUrl == null || response.AuthenticationUrl == '') {
                    iframe = null;
                    return;
                }
                windowObj.document.body.appendChild(iframe);
                windowObj.addEventListener('message', handleIframeResponse, false);
                iframe.src = response.AuthenticationUrl;
                setupBackgroundAuthTimeOut();
            }).catch(function (e) {
                iframe = null;
            });
            return [2 /*return*/];
        });
    });
}
exports.tryBackgroundAuth = tryBackgroundAuth;
function setupBackgroundAuthTimeOut() {
    // Run the time out function after one minute.
    setTimeout(function () {
        if (iframe != null) {
            cleanUpIframe();
        }
    }, ONEMINUTE);
}
function handleIframeResponse(e) {
    if (e.origin == windowObj.location.origin && e.data && e.data.split) {
        var action = e.data.split(':')[0];
        if (action == 'backgroundAuthResponse') {
            cleanUpIframe();
        }
    }
}
function cleanUpIframe() {
    windowObj.document.body.removeChild(iframe);
    iframe = null;
    windowObj.document.removeEventListener('message', handleIframeResponse);
}
